import { Service, ServiceInitializer } from 'elc-service';
import { SearchServiceStartedUseCase } from '../internal/use-cases/SearchServiceStartedUseCase';
import { SEARCH_RESULTS, SEARCH_GNAV_INPUT_FIELD, VOICE_SEARCH } from 'elc-service-view-names';

const packageInfo = require('../../package.json');
const { name, version } = packageInfo;

export class SearchService extends Service {
    constructor(serviceIntializer: ServiceInitializer) {
        super(name, version, serviceIntializer);
        this.registerView(SEARCH_RESULTS, () =>
            import(
                /* webpackChunkName: 'SearchResults'*/

                '../exported/search/SearchResults'
            )
        );
        this.registerView(SEARCH_GNAV_INPUT_FIELD, () =>
            import(
                /* webpackChunkName: 'SearchGnavInputField'*/

                '../exported/search/SearchGnavInputField'
            )
        );
        this.registerView(VOICE_SEARCH, () =>
            import(
                /* webpackChunkName: 'VoiceSearch'*/

                '../exported/search/VoiceSearch'
            )
        );
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public async start(config: any) {
        await super.start(config);

        const useCase = new SearchServiceStartedUseCase(['voiceSearch']);

        await useCase.execute();
    }
}
